"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function cov_1sozt0zuta() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/uuid.js";
  var hash = "194aca5f6e118e463227d456f45cb181bca5113f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/uuid.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 13
        },
        end: {
          line: 1,
          column: 14
        }
      },
      "1": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 14
        }
      },
      "2": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 15
          },
          end: {
            line: 3,
            column: 16
          }
        },
        loc: {
          start: {
            line: 3,
            column: 41
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 3
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 24
          },
          end: {
            line: 3,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 3,
            column: 33
          },
          end: {
            line: 3,
            column: 39
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "194aca5f6e118e463227d456f45cb181bca5113f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1sozt0zuta = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1sozt0zuta();
var lastId = (cov_1sozt0zuta().s[0]++, 0);
function _default() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1sozt0zuta().b[0][0]++, 'uuid');
  cov_1sozt0zuta().f[0]++;
  cov_1sozt0zuta().s[1]++;
  lastId += 1;
  cov_1sozt0zuta().s[2]++;
  return "".concat(prefix, "-").concat(lastId);
}